export const saveJson = async (data) => {
  const json = {
    name: "HTML Text Styler Theme",
    // unlock pro
    licenseKey: data.licenseKey,
    // content formatting
    showAsText: data.showAsText,
    outlineColor: data.outlineColor,
    fullWidth: data.fullWidth,
    hideScrollBar: data.hideScrollBar,
    // font formatting
    fontColor: data.fontColor,
    fontSize: data.fontSize,
    fontFamily: data.fontFamily,
    fontAlign: data.fontAlign,
    // grid
    showGrid: data.showGrid,
    outlineThickness: data.outlineThickness,
    rowPadding: data.rowPadding,
    columnPadding: data.columnPadding,
    scalingPercentage: data.scalingPercentage,
    // properties
    lockAspect: data.lockAspect,
    keepLayerOrder: data.keepLayerOrder,
    // title
    showTitle: data.showTitle,
    titleFontFamily: data.titleFontFamily,
    titleFontSize: data.titleFontSize,
    titleBold: data.titleBold,
    titleItalic: data.titleItalic,
    titleUnderline: data.titleUnderline,
    titleFontColor: data.titleFontColor,
    titleBackground: data.titleBackground,
    titleAlignment: data.titleAlignment,
    titleWrap: data.titleWrap,
    // effects
    // background
    showBackground: data.showBackground,
    backgroundColor: data.backgroundColor,
    backgroundTransparency: data.backgroundTransparency,
    // visual border
    showVisualBorder: data.showVisualBorder,
    visualBorderColor: data.visualBorderColor,
    visualBorderRadius: data.visualBorderRadius,
    // shadow
    showShadow: data.showShadow,
    showShadowColor: data.showShadowColor,
    showShadowPosition: data.showShadowPosition,
    showShadowPreset: data.showShadowPreset,
    showShadowSize: data.showShadowSize,
    showShadoBlur: data.showShadoBlur,
    showShadowAngle: data.showShadowAngle,
    showShadowDistance: data.showShadowDistance,
    showShadowTransparency: data.showShadowTransparency,
    // visual header
    showVisualHeader: data.showVisualHeader,
    visualHeaderBackground: data.visualHeaderBackground,
    visualHeaderBorder: data.visualHeaderBorder,
    visualHeaderForeground: data.visualHeaderForeground,
    visualHeaderTransparency: data.visualHeaderTransparency,
    showVisualInformationButton: data.showVisualInformationButton,
    showVisualWarningButton: data.showVisualWarningButton,
    showVisualErrorButton: data.showVisualErrorButton,
    showDrillRoleSelector: data.showDrillRoleSelector,
    showDrillUpButton: data.showDrillUpButton,
    showDrillToggleButton: data.showDrillToggleButton,
    showDrillDownLevelButton: data.showDrillDownLevelButton,
    showDrillDownExpandButton: data.showDrillDownExpandButton,
    showPinButton: data.showPinButton,
    showFocusModeButton: data.showFocusModeButton,
    showSeeDataLayoutToggleButton: data.showSeeDataLayoutToggleButton,
    showOptionsMenu: data.showOptionsMenu,
    showFilterRestatementButton: data.showFilterRestatementButton,
    showTooltipButton: data.showTooltipButton,
    //help tooltip
    visualHeaderTooltipFontFamily: data.visualHeaderTooltipFontFamily,
    visualHeaderTooltipFontSize: data.visualHeaderTooltipFontSize,
    visualHeaderTooltipColor: data.visualHeaderTooltipColor,
    visualHeaderTooltipBackground: data.visualHeaderTooltipBackground,
    visualHeaderTooltipTransparency: data.visualHeaderTooltipTransparency,
    //visual tooltip
    showVisualTooltip: data.showVisualTooltip,
    visualType: data.visualType,
    visualTypeFontFamily: data.visualTypeFontFamily,
    visualTypeFontSize: data.visualTypeFontSize,
    visualTypeBold: data.visualTypeBold,
    visualTypeItalic: data.visualTypeItalic,
    visualTypeUnderline: data.visualTypeUnderline,
    visualTypeTitleFontColor: data.visualTypeTitleFontColor,
    visualTypeValueFontColor: data.visualTypeValueFontColor,
    visualTypeBackground: data.visualTypeBackground,
    visualTypeTransparency: data.visualTypeTransparency,
  };
  const response = await fetch(
    `https://theme-generator-backend.azurewebsites.net/v1/json`,
    {
      method: "POST",
      body: JSON.stringify(json),
      headers: {
        "Content-Type": "application/json",
      },
    }
  );
  return await response.json();
};
